<template>
    <div class="bg-wrap">
        <div class="scroll">
            <div class="content-wrap">
                <div class="content">
                    <div class="item" >
                        <span class="info">
                        <span class="answer-key" v-html="toQuestion(question)" v-if="questionId!=-1"></span>
                        <span class="answer-value" :id="question.questionId+'-'+v.resolve_order" :class="'-'+question.questionId" v-for="(v,index) in question.resolves" v-bind:key="index" @click="check($event,question.sort)" data-light="0" :data-order="v.resolve_order">
                            {{v.resolve_order}}、{{v.resolve}}
                        </span>
                    </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="bottom">
            <div class="item" :class="rubEnable?'enable':'disable'" @click="toRub">
                <span>{{rub}}</span>
            </div>
            <div class="item " :class="subEnable?'enable':'disable'" @click="questionSubmit">
                <span>{{submit}}</span>
            </div>
        </div>

    </div>
</template>

<script>
    import {qCompQuestion, compEnable} from "../../assets/js/api";
    import {compQuestion,compSubmit} from "../../assets/js/api";

    export default {
        data() {
            return {
                title: "A卷 选择题（每题1分，共10道题，答题时间5分钟）",
                hint: "（每题1分，共10道题目，答题时间5分钟）",
                rub:"抢题",
                rubEnable:false,
                subEnable:false,
                submit: "提交",
                playerId:this.$store.state.playerId,
                question:"",
                type:2,
                questionId:"",
                myResolve:""
            }
        },
        mounted(){
            this.initWebSocket();
            this.getQuestion(this.playerId,this.type)
        },
        methods:{
            toRub(){
                if(!this.rubEnable) return

                let ele =  document.getElementsByClassName("answer-value");
                for(let item of ele){
                    item.setAttribute("data-light","0");
                }

                this.toCompQuestion(this.playerId,this.questionId)
            },
            toQuestion(question){
                return question.question + this.titleHint(question.sort)
            },
            titleHint(sort){
                switch (sort) {
                    case 1:
                        return "(单选题)"
                    case 2:
                        return "(判断题)"
                    case 3:
                        return "(多选题)"
                    default:
                        return ""
                }
            },
            async toCompEnable(questionId,type,playerId){
                const res = await compEnable({questionId,type,playerId})
                console.log(res,"1111")
                this.rubEnable = res.data.data.rubEnable
                this.subEnable = res.data.data.subEnable
            },
            async getQuestion(playerId,type){
                let res = await qCompQuestion({playerId,type})
                this.question = res.data.data
                this.questionId = res.data.data.questionId
                this.toCompEnable(this.questionId,this.type,this.playerId)
                this.myResolve = ""
                this.inital()
            },
            async toCompQuestion(playerId,questionId){
                const res = await compQuestion({playerId,questionId})
                console.log(res)
                if(res.data.success){
                    this.$toast("恭喜您抢到本题目")
                    this.toCompEnable(this.questionId,this.type,this.playerId)
                }else{
                    this.$toast(res.data.message)
                }
            },
            checkIndex(index){
                let charCode;
                let value =  index.toString(26).split("").map(function(item){
                    charCode = item.charCodeAt(0);
                    charCode+=(charCode>=97?10:49);
                    return String.fromCharCode(charCode)
                }).join("").toUpperCase();
                return value;
            },
            inital(){
                let value = document.getElementsByClassName('answer-value');
                for(let i=0;i<value.length;i++){
                    value[i].style.background = "transparent"
                }
            },
            check(event,sort){
                let id = event.currentTarget.id;

                let group =  id.split("-")[0];
                let groupValue = id.split("-")[1];

                if(sort==1||sort==2){ //单选或者判断题才会清除别的题目的高显
                    let value = document.getElementsByClassName('-'+group);
                    for(let i=0;i<value.length;i++){
                        value[i].style.background = "transparent"
                    }
                    document.getElementById(event.currentTarget.id).style.background="#0082C5";
                    document.getElementById(event.currentTarget.id).style.borderRadius="5px"
                }
                if(sort==3){//多选的情况下
                    groupValue=""
                    let light =  document.getElementById(event.currentTarget.id).getAttribute("data-light");
                    if(light==1){
                        document.getElementById(event.currentTarget.id).style.background="transparent";
                        document.getElementById(event.currentTarget.id).setAttribute("data-light","0");
                    }else{
                        document.getElementById(event.currentTarget.id).style.background="#0082C5";
                        document.getElementById(event.currentTarget.id).style.borderRadius="5px"
                        document.getElementById(event.currentTarget.id).setAttribute("data-light","1");
                    }
                    let value = document.getElementsByClassName('-'+group);
                    for(let i=0;i<value.length;i++){
                        if(value[i].getAttribute("data-light")==1){
                            groupValue+= value[i].getAttribute("data-order")+"、"
                        }
                    }
                }
                console.log(groupValue,"===groupValue===")
                this.myResolve = groupValue

            },
            questionSubmit(){
                /**
                 * 开始检查所有题目
                 */
                if(!this.subEnable) return;
                console.log(this.myResolve,"myResolve==")
                if(this.myResolve=='') {
                    this.$toast("请选择答案")
                    return;
                }
                this.toCompSubmit(this.playerId,this.questionId,this.myResolve,this.type)
            },
            async toCompSubmit(playerId,questionId,myResolve,type){
                const res = await compSubmit({playerId,questionId,myResolve,type})
                if(res.data.success==true){
                    this.$toast("提交成功");
                    this.getQuestion(this.playerId,this.type)
                    // this.$router.replace({path:"/playerIndex"})
                }
            },
            initWebSocket: function () {
                this.websock = new WebSocket("ws://server.iumed.com.cn/plus/one/websocket");
                // this.websock = new WebSocket("ws://192.168.31.230:9090/one/websocket");
                this.websock.onopen = this.websocketonopen;
                this.websock.onerror = this.websocketonerror;
                this.websock.onmessage = this.websocketonmessage;
                this.websock.onclose = this.websocketclose;
                console.log("--------websocketc初始化-------")
            },
            websocketonmessage: function (e) {
                console.log(e,"socket comming");
                this.getQuestion(this.playerId,this.type)
            },
        }
    }
</script>

<style scoped lang="scss">
    .bg-wrap {
        width: 100%;
        max-width: 375px;
        height: 100vh;
        background: transparent url("../../assets/img/qkds_bg_2.jpg") no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
        display: flex;
        flex-flow: column;
        position: relative;
    }

    .kv{
        width: 100%;
        height: 250px;
        background: #FFF url("../../assets/img/answer_kv.png") no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
        position: relative;
    }

    .kv .title {
        position: absolute;
        bottom: 0;
        color: #FFF;
        font-size: 13px;
        width: 90%;
        background: #d95c36;
        border-radius: 5px;
        height: 28px;
        line-height: 28px;
        margin-left: 20px;
        opacity: 0.8    ;
    }

    .scroll{
        /*flex-grow: 1;*/
        overflow: scroll;
    }

    .bottom{
        width: 100%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        position: absolute;
        bottom: 20%;
        .item{
            width: 90px;
            height: 40px;
            color: #FFF;
            line-height: 40px;
            /*background: #F29600;*/
            font-size: 20px;
            border-radius: 5px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .enable{
            background: #0082C5;
        }
        .disable{
            background: #333;
        }
    }


    .content-wrap {
        display: flex;
        flex-flow: column;
        align-items: center;
        position: relative;
    }


    .content {
        margin-top: 10px;
        /*height: 300px;*/
        width: 100%;
        margin-bottom: 50px;
    }

    .timer {
        position: absolute;
        right: 20px;
        top: 50px;
        width: 90px;
        height: 24px;
        line-height: 24px;
        font-size: 30px;
        font-weight: bold;
        color: #ffc336;
        border-radius: 5px;
        z-index: 100;
    }

    .item{
        display: flex;
        flex-flow: row;
        align-items: flex-start;
        color: #000;
        font-size: 20px;
        margin: 10px;
        text-align: left;
        .index{
            margin: 2px 10px 0 10px;
        }
        .info{
            display: flex;
            flex-flow: column;
            /*padding-bottom: 20px;*/
            /*border-bottom: 1px #b30b19 solid;*/
            flex-grow: 1;
        }
    }
    .info .answer-key{
        word-wrap:normal;
        word-break:break-all;
        margin-bottom: 5px;
        /*text-indent: 10px;*/
    }
    .info .answer-value{
        margin: 2px 20px;
        display: flex;
        flex-flow: row;
        justify-content: space-between;
        input[type="checkbox"]{
            margin-right: 50px;
        }
    }
</style>